import BaseMiddleware from "src/middleware/BaseMiddleware";

class AuthMiddleware extends BaseMiddleware {
  handle (from, to, next, args) {
    return next();
  }
}

export default AuthMiddleware;
